module.exports = __webpack_public_path__ + "img/LogoV2-Black_ClearBknd.25adefab.png";